import i18next from 'i18next';
import EN from './i18n/en.json';

i18next.addResourceBundle('en', 'importTemplate', EN);

const ImportTemplate = {};
export default ImportTemplate;
